export default {
  validObject: obj => !!obj && obj.constructor === Object
}
